<template>
    <div>
        <div>
        <img src="/static/img/aboutUs/about-title.jpg" alt="">
        <img src="/static/img/aboutUs/about-jianjie.jpg" alt="">
        <img src="/static/img/aboutUs/about-gswh.jpg" alt="">
        <img src="/static/img/aboutUs/about-team.jpg" alt="">
        <img src="/static/img/aboutUs/about-why.jpg" alt="">
        </div>
        <div class="bottom">
      <img src="/static/img/index/registered-bottom.jpg" alt />
    </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    created() {
        document.documentElement.scrollTop = 0
        document.title = '关于我们-麦德通—一站式VAT自主申报平台'
    }
}
</script>

<style scoped>
img{
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/aboutUs/index.vue